<template>
  <v-container class="article-container">
    <v-img
      v-if="article.coverImage"
      :src="imageDir + article.coverImage"
      aspect-ratio="2"
      gradient="to bottom, rgba(6,9,15,.5), rgba(6,9,15,.8)"
      class="article-header">
      <h1
        v-if="article.title"
        class="article-header__title">
        {{ article.title }}
      </h1>
      <h2
        v-if="article.subtitle"
        class="article-header__subtitle">
        {{ article.subtitle }}
      </h2>
      <h3 class="article-header__date">{{ dateCreated }}</h3>
      <h3 class="article-header__author">Written By {{ article.author }}</h3>
    </v-img>
    <!-- eslint-disable -->
    <article
      v-html="parsedArticle"
      class="article-body">
    </article>
    <!-- eslint-enable -->
  </v-container>
</template>

<script>
import marked from 'marked';

import { mapState } from 'vuex';

export default {
  name: 'SingleArticle',
  data() {
    return {
      markedConfig: {
        baseUrl: '',
        smartypants: true,
      },
      parsedArticle: '',
    };
  },
  computed: {
    ...mapState('articles', {
      article: 'article',
      imageDir: 'imageDir',
      loading: 'loading',
      errorMessage: 'errorMessage',
    }),
    dateCreated() {
      return this.moment(this.article.dateCreated).format('MMMM Do YYYY');
    },
  },
  created() {
    this.$store
      .dispatch('articles/getArticleBySlug', this.$route.params.slug)
      .then(() => {
        this.markedConfig.baseUrl = this.imageDir;
        this.parsedArticle = marked(this.article.content, this.markedConfig);
      });
  },
};
</script>

<style lang="stylus" scoped>
@require('../../stylus/base')

.article-container
  max-width: 64rem

.article-header
  align-items: center
  justify-content: center
  padding: $base-padding*2
  color: $secondary
  border-radius: $base-border-radius
  &__title,
  &__subtitle,
  &__author,
  &__date
    text-align: center
  &__title
    font-size: 1.75rem
  &__subtitle
    padding-bottom: $base-padding*2
    font-size: 1.25rem
    font-weight: 300
  &__date,
  &__author
    font-size: $font-size--small
    font-style: italic
    opacity: .75

.article-body
  margin-top: $base-padding*4
  padding-top: $base-padding
  border-top: 1px solid $accent
  // use deep-scope selector to style article html
  // https://vue-loader.vuejs.org/guide/scoped-css.html#deep-selectors
  >>>img
    max-width: 100%
    max-height: 48rem
    box-shadow: $base-box-shadow
</style>
